import { ActionMenu, ConfirmationDialog } from '@ijoin/components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';

import { useToggle } from 'usehooks-ts';

const REPROCESSABLE_STATUSES = ['canceled', 'stalled'];

const CANCELABLE_STATUSES = [
  'liquidationRequested',
  'onHold',
  'pending',
  'stalled'
];

export const AutoForceOutActionsCell = (props: {
  distributionStatus?: null | string;
  onCancel: () => void;
  onReprocess: () => void;
  participantName: string;
  rolloverParticipantId: string;
}) => {
  const [isReprocessOpen, toggleReprocessOpen] = useToggle();
  const [isCancelOpen, toggleCancelOpen] = useToggle();

  const onConfirmReprocess = () => {
    toggleReprocessOpen();
    props.onReprocess();
  };

  const onConfirmCancel = () => {
    toggleCancelOpen();
    props.onCancel();
  };

  return (
    <>
      <ActionMenu
        actions={[
          {
            content: 'Reprocess',
            disabled: !REPROCESSABLE_STATUSES.includes(
              props.distributionStatus ?? ''
            ),
            onSelect: toggleReprocessOpen
          },
          {
            content: 'Cancel candidate',
            disabled: !CANCELABLE_STATUSES.includes(
              props.distributionStatus ?? ''
            ),
            onSelect: toggleCancelOpen
          }
        ]}
        trigger={
          <IconButton
            data-component='actionsMenu'
            data-testid={`actionsAutoForceOut-${props.rolloverParticipantId}`}>
            <MoreVertIcon />
          </IconButton>
        }
      />
      {isReprocessOpen && (
        <ConfirmationDialog
          confirmText='Reprocess'
          data-testid={`reprocessAutoForceOut-${props.rolloverParticipantId}`}
          isOpen={isReprocessOpen}
          message={`This clears the stall on ${props.participantName} and resets its failed attempt count. The nightly force out job will retry the candidate on its next run.`}
          onCancel={toggleReprocessOpen}
          onConfirm={onConfirmReprocess}
          title='Reprocess Force Out Candidate'
        />
      )}
      {isCancelOpen && (
        <ConfirmationDialog
          confirmationText='CANCEL'
          confirmColor='error'
          confirmText='Cancel candidate'
          data-testid={`cancelAutoForceOut-${props.rolloverParticipantId}`}
          isOpen={isCancelOpen}
          message={`This permanently removes ${props.participantName} from the automated force out pipeline. They can only re-enter it by being identified again on a later sweep.`}
          onCancel={toggleCancelOpen}
          onConfirm={onConfirmCancel}
          title='Cancel Force Out Candidate'
        />
      )}
    </>
  );
};
